import { Badge } from "@/common/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/common/ui/table";

import { feedbackDetail, summarizeKind } from "./summarize";
import type { FeedbackItem } from "./types";

interface FeedbackTableProps {
  feedback: FeedbackItem[];
}

const dateFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "short",
});

export function FeedbackTable({ feedback }: FeedbackTableProps): React.ReactElement {
  return (
    <div data-testid="feedback-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Kind</TableHead>
            <TableHead>Detail</TableHead>
            <TableHead className="hidden sm:table-cell">Status</TableHead>
            <TableHead className="hidden md:table-cell">Submitted</TableHead>
            <TableHead className="hidden lg:table-cell">Workspace</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {feedback.map((item) => (
            <TableRow key={item.id} data-testid={`feedback-row-${item.id}`}>
              <TableCell className="whitespace-nowrap font-medium">
                {summarizeKind(item.content)}
              </TableCell>
              <TableCell
                data-testid={`feedback-detail-${item.id}`}
                className="max-w-md truncate text-muted-foreground"
                title={feedbackDetail(item.content)}
              >
                {feedbackDetail(item.content) || "(none)"}
              </TableCell>
              <TableCell className="hidden sm:table-cell">
                <Badge variant="secondary">{item.status}</Badge>
              </TableCell>
              <TableCell className="hidden whitespace-nowrap md:table-cell">
                {dateFormatter.format(new Date(item.submittedAt))}
              </TableCell>
              <TableCell className="hidden font-mono text-xs text-muted-foreground lg:table-cell">
                {item.tenantId}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
